import { map } from 'rxjs/operators';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import { ModalViewSouscripteurDetailComponent } from "src/app/shared/components/modal-view-souscripteur-detail/modal-view-souscripteur-detail.component";
import { ModalViewBeneficiaireDetailComponent } from "src/app/shared/components/modal-view-beneficiaire-detail/modal-view-beneficiaire-detail.component";
import { ModalViewProduitDetailComponent } from "src/app/shared/components/modal-view-produit-detail/modal-view-produit-detail.component";
import { ModalViewProduitBaremeComponent } from "src/app/shared/components/modal-view-produit-bareme/modal-view-produit-bareme.component";
import { ModalViewGarantDetailsComponent } from "src/app/shared/components/modal-view-garant-details/modal-view-garant-details.component";
import { ModalViewCollegeDetailComponent } from "src/app/shared/components/modal-view-college-detail/modal-view-college-detail.component";
import { ModalViewPoliceDetailsComponent } from "src/app/shared/components/modal-view-police-details/modal-view-police-details.component";
import { ModalAddGarantComponent } from "../../garant/modal-add-garant/modal-add-garant.component";
import { ModalAddSouscripteurComponent } from "../../souscripteur/modal-add-souscripteur/modal-add-souscripteur.component";
import { ModalAddCommercialComponent } from "src/app/parametres/param-divers/commercial/modal-add-commercial/modal-add-commercial.component";
import { ModalAddCourtierComponent } from "../../courtier/modal-add-courtier/modal-add-courtier.component";
import { ModalViewCoutierDetailComponent } from "src/app/shared/components/modal-view-coutier-detail/modal-view-coutier-detail.component";

@Component({
  selector: 'app-modal-add-police',
  templateUrl: './modal-add-police.component.html',
  styleUrls: ['./modal-add-police.component.scss']
})
export class ModalAddPoliceComponent implements OnInit {

  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id: any
  uniteFonctionnelleSelected: any = {};
  isDetailMode: boolean = false
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true
  busyGet: Subscription;
  itemsListeModeGestAvenant: any = [{ value: 'MANUEL', libelle: 'MANUEL' }, { value: 'AUTOMATIQUE', libelle: 'AUTOMATIQUE' }]
  itemsPeriodiciteAvenant: any = [{ value: 'JOUR', libelle: 'JOUR' }, { value: 'MOIS', libelle: 'MOIS' }, { value: 'TRIMESTRE', libelle: 'TRIMESTRE' }, { value: 'SEMESTRE', libelle: 'SEMESTRE' }, { value: 'ANNEE', libelle: 'ANNEE' }, { value: 'EXERCICE', libelle: 'EXERCICE' }]
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "police";
  title: string = 'police'
  createMessage = ''
  editMessage = ''
  deleteMessage = ''
  itemsParentFonctionnalites = []
  itemsRemboursement = [
    { code: 'ASSURE', libelle: 'ASSURE PRINCIPAL' },
    { code: 'CONJOINT', libelle: 'CONJOINT' },
    { code: 'SOUSCRIPTEUR', libelle: 'SOUSCRIPTEUR' },
    { code: 'ENFANT', libelle: 'ENFANT' },
    { code: 'ASCENDANT', libelle: 'ASCENDANT' },
  ]

  itemsSourceFondCaution:any=[{code:'PROVISION-SINISTRE',libelle:'Provision sinistre'},{code:'FORFAIT',libelle:'Forfait'}]
  itemsSourceFondSinistre:any=[{code:'PROVISION-SINISTRE',libelle:'Provision sinistre'},{code:'SINISTRE-REEL',libelle:'Sinistre réel'}]
  itemsSourceFondHonoraire:any=[
    {code:'PROVISION-SINISTRE',libelle:'Provision sinistre'},
    {code:'SINISTRE-REEL',libelle:'Sinistre réel'},
    {code:'FORFAIT',libelle:'Forfait'},
    {code:'PRIME',libelle:'Prime'},
  ]
  periodicite:any=[
    {code:'MOIS',libelle:'Mois'},
    {code:'TRIMESTRE',libelle:'TRIMESTRE'},
    {code:'SEMESTRE',libelle:'SEMESTRE'},
    {code:'ANNEE',libelle:'ANNEE'},
  ]
  assietteDeFond:any=[
    {code:'GARANT',libelle:'Garant'},
    {code:'FAMILLE',libelle:'Famille'},
    {code:'BENEFICIAIRE',libelle:'Bénéficiaire'},
    {code:'AUCUNE',libelle:'Aucune'},
  ]

  gender = 'F'
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = []
  itemsGenre: any = []
  itemsFiliale: any = []
  searchKey: any
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  itemsIntermediaire:any=[]
  itemsApporteur:any=[]
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeRemboursement: any;
  itemsCourtier: any[];
  itemsCommercial: any;
  itemsSouscripteur: any;
  itemsCategoriePolice: any[];
  currentData: any
  itemsModeTarification: any;
  itemsReseauDeSoin: any;
  itemsGarant: any;
  itemsAgence: any[];
  itemsStatutPolice: any;
  itemsModeReconduction: any;
  itemsModeFractionnement: any[];
  itemsTypeContrat: any[];
  itemsModeProrata: any;
  systemGlobal: any;
  is_tpg: boolean;
  itemsTarif: any = [];
  itemsTypeTarif: any = [];
  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser()
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id
    let text1 = this.gender == 'M' ? 'un' : 'une'
    this.createMessage = 'Vous êtes sur le point de créer ' + text1 + ' ' + this.title
    this.editMessage = 'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title

    this.systemGlobal = JSON.parse(localStorage.getItem("globalSystem"));
    // console.log('systemGlobal: ',JSON.stringify(this.systemGlobal))
    if (this.systemGlobal && this.systemGlobal.length) {
      let mode_gestion_avant_systeme = this.systemGlobal.find(
        (sg: any) => sg.codification == "mode_gest_avenant"
      ).valeur;

      let periodicite_avenant_systeme = this.systemGlobal.find(
        (sg: any) => sg.codification == "periodicite_avenant"
      ).valeur;
      this.itemToSave.mode_gest_avenant = mode_gestion_avant_systeme
      this.itemToSave.periodicite_avenant = periodicite_avenant_systeme
    }

    this.setSystemAvenantConfig()

    setTimeout(() => {
      console.log('here');
      this.itemToSave.date_effet = new Date()
      this.itemToSave.date_echeance = new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999);
      if (this.currentData) {
        console.log('currentData: ', this.currentData)
        this.itemToSave = Object.assign({}, this.currentData);
        this.itemToSave.date_effet = this.itemToSave.date_effet ? moment(this.itemToSave.date_effet).toDate() : new Date()
        this.itemToSave.date_echeance = this.itemToSave.date_echeance ? moment(this.itemToSave.date_echeance).toDate() : new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999)
        // this.itemToSave.date_effet = this.itemToSave.date_effet?moment(this.itemToSave.date_effet).format('MMMM Do YYYY, h:mm:ss a'):new Date()
        // this.itemToSave.date_echeance = this.itemToSave.date_echeance?moment(this.itemToSave.date_echeance).format('MMMM Do YYYY, h:mm:ss a'):new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999)
      }

        // console.log("sessionMode in police: ",this.currentData.sessionMode)
    }, 50);

  }

  on_change_garant() {
    if (this.itemsGarant && this.itemsGarant.length) {
      let current_garant = { ...this.itemsGarant.filter(ig => ig.id == this.itemToSave.garant_id)[0] }
      console.log('current_garant: ', current_garant)
      this.setSystemAvenantConfig()
      this.setGarantAvenantConfig(current_garant)


      if (!this.itemToSave.id) {
        this.itemToSave.taux_commission_sinistre = current_garant.taux_commission_sinistre
        this.itemToSave.forfait_commission_sinistre = current_garant.forfait_commission_sinistre
        this.itemToSave.taux_commission_prime = current_garant.taux_commission_prime
        this.itemToSave.forfait_commission_prime = current_garant.forfait_commission_prime
        this.itemToSave.type_remboursement_id = current_garant.type_remboursement_id
        this.itemToSave.seuil_alerte_conso = current_garant.seuil_alerte_conso
        this.itemToSave.seuil_suspension_tiers_payant = current_garant.seuil_suspension_tiers_payant
        this.itemToSave.assure_remboursement = current_garant.assure_remboursement
        this.itemToSave.mode_tarification_id = current_garant.mode_tarification_id
        this.itemToSave.mode_reconduction_id = current_garant.mode_reconduction_id
        this.itemToSave.mode_fractionnement_id = current_garant.mode_fractionnement_id
        this.itemToSave.reseau_de_soin_id = current_garant.reseau_de_soin_id
        this.itemToSave.is_prorata_prime = current_garant.is_prorata_prime
      }


      
    }

  }

  onSelectTypeRemboursement() {
    let selected_type_remboursement = this.itemsTypeRemboursement.find(itr => itr.id == this.itemToSave.type_remboursement_id)
    this.is_tpg = selected_type_remboursement && selected_type_remboursement.codification == 'TPG'
    if (!this.itemToSave.taux_tpg) {
      this.itemToSave.taux_tpg = 100
    }
    if (!this.itemToSave.plafond_tpg) {
      this.itemToSave.plafond_tpg = 0
    }
    if (!this.itemToSave.majoration_tpg) {
      this.itemToSave.majoration_tpg = 0
    }
  }

  setGarantAvenantConfig(current_garant) {
    if (current_garant.mode_gest_avenant) {
      this.itemToSave.mode_gest_avenant = current_garant.mode_gest_avenant
    }
    if (current_garant.periodicite_avenant) {
      this.itemToSave.periodicite_avenant = current_garant.periodicite_avenant

    }
  }
  setSystemAvenantConfig() {
    this.systemGlobal = JSON.parse(localStorage.getItem("globalSystem"));
    // console.log('systemGlobal: ',JSON.stringify(this.systemGlobal))
    if (this.systemGlobal && this.systemGlobal.length) {
      this.itemToSave.mode_gest_avenant = this.systemGlobal.find(
        (sg: any) => sg.codification == "mode_gest_avenant"
      ).valeur;

      this.itemToSave.periodicite_avenant = this.systemGlobal.find(
        (sg: any) => sg.codification == "periodicite_avenant"
      ).valeur;
    }

  }
  confirmSaveItem(item) {
    console.info('item: ', item)

    console.info(" itemToSave ", this.itemToSave);
    console.info(" item ", item);


    if (!item.id && !item.code)
      item.code = this.generateUniqueString()

    // if (!item.id && !item.codification)
    //   item.codification = this.generateUniqueString()


    // item.specialiteId = this.selectedSpecialite.id

    if (!item || !item.garant_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner garant !",
        "bottom",
        "center"
      );
      return;
    }

  



    if (!item || !item.souscripteur_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner souscripteur!",
        "bottom",
        "center"
      );
      return;
    }



    if (!item || !item.date_effet) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner date effet!",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.date_echeance) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner date echéance!",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.plafond) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner plafond!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.categorie_police_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner catégorie!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.type_remboursement_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner catégorie!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.libelle) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner libellé!",
        "bottom",
        "center"
      );
      return;
    }
    // if (!item || !item.reseau_de_soin_id) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner commercial!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // if (item.is_prorata_prime && !item.mode_prorata_id) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner le mode de prorata!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    // if (!item.mode_gest_avenant) {
    //   this.utilities.showNotification(
    //    "snackbar-danger",
    //     "Veuillez renseigner le mode gestion avenant!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // } 
    // if (!item.periodicite_avenant) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner périodicité avenant!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }



    item.type_id = item.type
    if (item.id) {
      delete item.type;
    }

    let objToSave = Object.assign({}, item);


    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id
        ? this.editMessage
        : this.createMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        ;
        this.saveItem(objToSave);
      }
    });
  }

  getItemsTarif() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        type_tarif_id: this.itemsTypeTarif.find(
          (itt) => itt.codification == "TAR-POL"
        ).id,
      },
    };

    this.busyGet = this.restClient
      .post("tarif/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTarif = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsTarif = [];
          }
        },
        (err) => {
          this.itemsTarif = [];
        }
      );
  }
  getItemsApporteur() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
       
      },
    };

    this.busyGet = this.restClient
      .post("apporteur/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsApporteur = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsApporteur = [];
          }
        },
        (err) => {
          this.itemsApporteur = [];
        }
      );
  }

  getItemsIntermediaire() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        
      },
    };

    this.busyGet = this.restClient
      .post("intermediaire/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsIntermediaire = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsIntermediaire = [];
          }
        },
        (err) => {
          this.itemsIntermediaire = [];
        }
      );
  }


  getItemsTypeTarif() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        // type_tarif_id:this.itemto
      },
    };

    this.busyGet = this.restClient
      .post("typeTarif/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeTarif = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsTypeTarif = [];
          }
          this.getItemsTarif();
        },
        (err) => {
          this.itemsTypeTarif = [];
        }
      );
  }



  saveItem(item) {
    console.info("item to save", item);

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);
    let reduce = [];
    itemAEnregistrer.filiale_id = this.filiale_id || this.user.filiale_id

    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }
    var request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post(
        this.endPoint + "" + (itemAEnregistrer.id ? "/update" : "/create"),
        request
      )
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );

            this.bsModalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  addDocument(event) {
    console.log("addDocument: ", event);
    // this.datasFile = event;
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

  getItemsTypeRemboursement() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeRemboursement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeRemboursement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
            if (this.itemToSave.id) {
              this.onSelectTypeRemboursement()
            }
          } else {
            this.itemsTypeRemboursement = [];
          }
        },
        (err) => {
          this.itemsTypeRemboursement = [];

        }
      );
  }
  getItemsCourtier() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("courtier/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCourtier = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCourtier = [];
          }
        },
        (err) => {
          this.itemsCourtier = [];

        }
      );
  }

  getItemsCommercial() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("commercial/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCommercial = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCommercial = [];
          }
        },
        (err) => {
          this.itemsCommercial = [];

        }
      );
  }

  getItemsModeTarification() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeTarification/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeTarification = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeTarification = [];
          }
        },
        (err) => {
          this.itemsModeTarification = [];

        }
      );
  }
  getItemsModeReconduction() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeReconduction/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeReconduction = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeReconduction = [];
          }
        },
        (err) => {
          this.itemsModeReconduction = [];

        }
      );
  }
  getItemsModeFractionnement() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeFractionnement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeFractionnement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeFractionnement = [];
          }
        },
        (err) => {
          this.itemsModeFractionnement = [];

        }
      );
  }
  getItemsSouscripteur() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("souscripteur/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            res["items"].map(it => {
              it.libelle = it.libelle ? it.libelle : it.nom + ' ' + it.prenom
            })
            this.itemsSouscripteur = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsSouscripteur = [];
          }
        },
        (err) => {
          this.itemsSouscripteur = [];

        }
      );
  }
  getItemsCategoriePolice() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("categoriePolice/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCategoriePolice = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCategoriePolice = [];
          }
        },
        (err) => {
          this.itemsCategoriePolice = [];

        }
      );
  }

  getItemsReseauDeSoin() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("reseauDeSoin/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsReseauDeSoin = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsReseauDeSoin = [];
          }
        },
        (err) => {
          this.itemsReseauDeSoin = [];

        }
      );
  }
  getItemsGarant() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("garant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGarant = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsGarant = [];
          }
        },
        (err) => {
          this.itemsGarant = [];

        }
      );
  }
  getItemsAgence() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("agence/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsAgence = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsAgence = [];
          }
        },
        (err) => {
          this.itemsAgence = [];

        }
      );
  }

  getItemsStatutPolice() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statutPolice/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatutPolice = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsStatutPolice = [];
          }
        },
        (err) => {
          this.itemsStatutPolice = [];

        }
      );
  }

  getItemsTypeContrat() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeContrat/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeContrat = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsTypeContrat = [];
          }
        },
        (err) => {
          this.itemsTypeContrat = [];

        }
      );
  }
  // onSelectDate(event) {
  //   if (event) {
  //     (this.dateNais = moment(event).format("DD/MM/YYYY")),
  //       console.info("dateNais", this.dateNais);
  //   }
  // }

  isValidEmail(email) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }



  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  load_filiale_data() {
    // this.getItems();
    this.getItemsTypeRemboursement()
    this.getItemsCourtier()
    this.getItemsCommercial()
    this.getItemsSouscripteur()
    this.getItemsCategoriePolice()
    this.getItemsModeTarification()
    this.getItemsModeReconduction()
    this.getItemsReseauDeSoin()
    this.getItemsGarant()
    this.getItemsAgence()
    this.getItemsModeFractionnement()
  }

  openModalPrestataireReseau() {
    if (!this.itemToSave.reseau_de_soin_id)
      return
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 5458545,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let reseau_id = this.itemToSave.reseau_de_soin_id
    let reseau_de_soin_libelle = this.itemsReseauDeSoin.filter(ird => ird.id == reseau_id)[0].libelle
    let data = { reseau_de_soin_id: reseau_id, reseau_de_soin_libelle: reseau_de_soin_libelle }
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
    });
  }

  onPenDetailModal(item, type) {
    let data: any = ''
    let modalSize = "modal-width-75";

    let modal: any;
    if (type == 'beneficiaire') {
      modal = ModalViewBeneficiaireDetailComponent;
      data = { id: this.itemToSave.beneficiaire_id }
    }
    if (type == 'produit') {
      modal = ModalViewProduitDetailComponent;
      data = { id: this.itemToSave.produit_id }
    }
    if (type == 'produitBareme') {
      modal = ModalViewProduitBaremeComponent;
      data = { id: this.itemToSave.produit_bareme_id }
    }
    if (type == 'garant') {
      modal = ModalViewGarantDetailsComponent;
      data = { id: this.itemToSave.garant_id }
    }
    if (type == 'college') {
      modal = ModalViewCollegeDetailComponent;
      data = { id: this.itemToSave.college_id }
    }

    if (type == 'police') {
      modal = ModalViewPoliceDetailsComponent;
      data = { id: this.itemToSave.police_id }
    }
    if (type == 'souscripteur') {
      modal = ModalViewSouscripteurDetailComponent;
      data = { id: this.itemToSave.souscripteur_id }
    }
    if (type == 'courtier') {
      modalSize = "modal-width-65";
      modal = ModalViewCoutierDetailComponent;
      data = { id: this.itemToSave.courtier_id }
    }

    this.modalRef = this.modalService.show(modal, {
      id: 545805401005,
      class: modalSize,
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => { });
  }


  openModalAddSouscripteur() {
    let modal: any;
    modal = ModalAddSouscripteurComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545850434345,
      class: "modal-width-75",
      ignoreBackdropClick: true,
    });

    let souscripteur_libelle = "";
    // let data = { souscripteur_id: {...this.itemToSave}.souscripteur_id, souscripteur_libelle: souscripteur_libelle };
    // if (data) this.modalRef.content.currentData = data;

    // Local onHide subscription
    if (this.modalRef.onHide) {
      this.modalRef.onHide.subscribe(() => {
        console.log("Modal hidden (local onHide)");
        this.getItemsSouscripteur();
      });
    }

    // Fallback to global onHide subscription
    this.modalService.onHide.subscribe(() => {
      console.log("Modal hidden (global onHide)");
      this.getItemsSouscripteur();
    });
  }


  // openModalSouscripteur() {
  //   // if(!this.itemToSave.souscripteur_id)
  //   //   return
  //   let modal: any;
  //   modal = ModalViewSouscripteurDetailComponent;
  //   this.modalRef = this.modalService.show(modal, {
  //     id: 54585045,
  //     class: "modal-width-75",
  //     ignoreBackdropClick: true,
  //     // data:boulangerie
  //   });

  //   let souscripteur_libelle =this.itemsSouscripteur.filter(is=>is.id == this.itemToSave.souscripteur_id)[0].libelle
  //   let data = {souscripteur_id:this.itemToSave.souscripteur_id,souscripteur_libelle:souscripteur_libelle}
  //   if (data) this.modalRef.content.currentData = data;
  //   this.modalRef.onHide.subscribe((res) => {
  //   });
  // }

  openModalGarantComponent(data?) {
    let modal: any;
    modal = ModalAddGarantComponent;
    this.modalRef = this.modalService.show(modal, {
      id: this.generateUniqueString(),
      class: "modal-width-75",
      ignoreBackdropClick: true,

      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.currentPage = 0
      this.getItemsGarant();
    });
  }

  openModalSouscripteurComponent(data?) {
    let modal: any;
    modal = ModalAddSouscripteurComponent;
    this.modalRef = this.modalService.show(modal, {
      id: this.generateUniqueString(),
      class: "modal-width-75",
      ignoreBackdropClick: true,

      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.currentPage = 0
      this.getItemsSouscripteur();
    });
  }

  openModalCommercialComponent(data?) {
    let modal: any;
    modal = ModalAddCommercialComponent;
    this.modalRef = this.modalService.show(modal, {
      id: this.generateUniqueString(),
      class: "modal-width-50",
      ignoreBackdropClick: true,

      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.currentPage = 0
      this.getItemsCommercial();
    });
  }

  openModalCourtierComponent(data?) {
    let modal: any;
    modal = ModalAddCourtierComponent;
    this.modalRef = this.modalService.show(modal, {
      id: this.generateUniqueString(),
      class: "modal-width-50",
      ignoreBackdropClick: true,

      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.currentPage = 0
      this.getItemsCourtier();
    });
  }


  uploadFile(event: any) {
    console.log('event: ', event)
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split(".")[0];
      const Tabextension = file.name.split(".");
      const extension = Tabextension[Tabextension.length - 1];

      console.info("fileName", fileName);
      console.info("extension", extension);
      this.imageName = fileName + "." + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(",")[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: "custom type",
        };
        // console.log('currentItemImage: ',this.currentItemImage)
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  getItemsModeProrata() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeProrata/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeProrata = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeProrata = [];
          }
        },
        (err) => {
          this.itemsModeProrata = [];

        }
      );
  }


  onChangeSourceFondCaution(){}
onChangePeriodiciteFondSinistre(){}
onChangePeriodiciteFondHonoraire(){}
onChangePeriodiciteDeficit(){}
onChangeSourceFondHonoraire(){}
onChangeSourceFondSinistre(){
  console.log("itemToSave.source_fond_sinistre: ",this.itemToSave.source_fond_sinistre)
  if(this.itemToSave.source_fond_sinistre=='SINISTRE-REEL'){
    this.itemToSave.assiete_fond_sinistre='AUCUNE'
  }
}


onChangeAssieteSinistre(){}
onChangeAssieteHonoraire(){}
onChangeAssieteCaution(){}

  ngOnInit() {


    this.getItemsFiliale();
    this.load_filiale_data()
    this.getItemsModeProrata()
    this.getItemsTypeTarif()
    this.getItemsIntermediaire() 
    this.getItemsApporteur() 
  }

}
